<template>
  <fhir-reference-report
      v-if="($router.history.current.path === '/resource/search/practitionerrole' && label==='Facility') || ($router.history.current.path === '/resource/search/organization' && label==='Facility') || ($router.history.current.path === '/resource/search/manage-position' && label==='Facility')"
      baseMax="1"
      baseMin="0"
      constraints=undefined
      edit=true
      field="partOf"
      initialValue="Location/federal-ministry-of-health"
      label="Facility"
      max="1"
      min="0"
      overrideValue=undefined
      path="Location.partOf"
      readOnlyIfSet:undefined
      sliceName:undefined
      slotProps:Object
      source:Object
      subFields:undefined
      targetProfile="http://ihris.org/fhir/StructureDefinition/ihris-facility"
      targetResource="Location"
      returnAll=true
      @selectedFacility="onSelectedFacility"
  >
  </fhir-reference-report>
  <fhir-reference-department v-else-if="(label==='Department or CaseTeam' && expression === 'department')"
   baseMax="1"
      baseMin="0"
      constraints=undefined
      edit=true
      field="partOf"
      initialValue=""
      :label="label"
      max="1"
      min="0"
      overrideValue=undefined
      path="Organization.partOf"
      readOnlyIfSet:undefined
      sliceName:undefined
      slotProps:Object
      source:Object
      subFields:undefined
      targetProfile="http://ihris.org/fhir/StructureDefinition/ihris-organization"
      targetResource="Organization"
      returnAll=true
      @selectedDepartment="onSelectedDepartment"
  ></fhir-reference-department>
  <v-select
      v-else-if="binding"
      v-model="value"
      :error="error"
      :error-messages="err_messages"
      :items="items.filter(x => !x.code.includes('(deactivated)'))"
      :label="label"
      :loading="loading"
      clearable
      dense
      hide-details
      item-text="display"
      item-value="code"
      multiple
      outlined
      class="ma-2"
      small-chips
      @change="updateSearch()"
      @click:clear="clearSearch()"
  >
  </v-select>
  <v-text-field
      v-else
      v-model="value"
      :label="label"
      clearable
      dense
      hide-details
      outlined
      class="ma-2"
      @change="updateSearch()"
      @click:clear="clearSearch()"
  >
  </v-text-field>
</template>

<script>
import FhirReferenceReport from "../fhir/fhir-referense-report";
import FhirReferenceDepartment from "@/components/fhir/fhir-referense-department.vue";

export default {
  name: "ihris-search-term",
  components: {FhirReferenceDepartment, FhirReferenceReport},
  props: ["label", "expression", "binding"],
  data: function () {
    return {
      loading: false,
      items: [],
      error: false,
      err_messages: null,
      value: [],
    };
  },
  mounted: function () {
    this.loading = true;
    this.$fhirutils
        .expand(this.binding)
        .then((items) => {
          this.items = items;

          this.loading = false;
        })
        .catch((err) => {
          this.error = true;
          this.err_messages = err.message;
          this.loading = false;
        });
  },
  methods: {
    onSelectedFacility: function (val) {
      this.$root.$emit("facilityIsSelectedForDept", val);
      if(val.length>0){
        this.value = val.map(x => x.id.split('/').pop())
      }else if(val.length === 0){
        this.value = []
      }
      this.updateSearch()
    },
    onSelectedDepartment: function (val) {
      if(val.length>0){
        this.value = val.map(x => x.id.split('/').pop())
      }else if(val.length === 0){
        this.value = []
      }
      this.updateSearch()
      // this.$emit("termChange", this.expression, val);
    },
    updateSearch: function () {
      this.$emit("termChange", this.expression, this.value);
    },
    clearSearch: function () {
      this.$emit("termChange", this.expression, []);
    },
  },
};
</script>
